import React from "react";
import { withStyles } from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import { theme } from "@themes";

export const AntSubTab = withStyles((muiTheme) => ({
    root: {
      textTransform: "none",
      minWidth: 50,
      fontWeight: muiTheme.typography.fontWeightRegular,
      marginRight: muiTheme.spacing(0),
      "&:hover": {
        color: theme.primary.purple,
        fontWeight: muiTheme.typography.fontWeightBold,
        opacity: 1,
      },
      "&$selected": {
        color: theme.primary.purple,
        fontWeight: muiTheme.typography.fontWeightBold,
        opacity: 1,
      },
      "&:focus": {
        color: theme.primary.purple,
        fontWeight: muiTheme.typography.fontWeightBold,
        opacity: 1,
      },
    },
    selected: {},
  }))((props) => <Tab disableRipple {...props} />);